// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container_2s4rm","chevron":"Detail_chevron_3le21","usersTable":"Detail_usersTable_Tk3tc"};